// Batch 21 · readable URLs. Category pages live at /stores, /events, …; entries at /<category>/<slug>.
// Entries without a slug (shouldn't happen after the startup backfill) fall back to /e/<id>,
// which keeps working forever and redirects to the readable address.
export const CATEGORY_PATHS = ["stores", "events", "creators", "vending", "vendors"];

export function catPath(id) {
  return `/${id}`;
}

export function entryPath(entry) {
  if (entry && entry.slug && CATEGORY_PATHS.includes(entry.category)) return `/${entry.category}/${entry.slug}`;
  return `/e/${entry?.id || entry?.entry_id || ""}`;
}
